import { Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from 'react-i18next';

const bucketSize = 100000;

const BudgetField = ({capBucket, setCapBucket, price}) => {
    const { t } = useTranslation();

    return (
        <>
            <Typography sx={{ mt: 2.5, fontWeight: 700 }}>{t('settings.budget')}</Typography>
            <Grid container spacing={2} mt={1}>
                <Grid item md={2}>
                    <TextField type="number" variant="outlined" fullWidth onChange={e => setCapBucket(Math.floor(e.target.value))} value={capBucket} />
                </Grid>
                <Grid item md={10} alignItems={"stretch"} style={{display: "flex", flexDirection: 'column', justifyContent: 'center'}}>
                    x {bucketSize.toLocaleString()} = {(capBucket*bucketSize).toLocaleString()} {t('settings.requestsPerMonth', { cost: (capBucket*price).toLocaleString() })}
                </Grid>
            </Grid>
            <Typography variant="body2" sx={{ mt: 1.25, color: (theme) => theme.custom.muted }}>
                {t('settings.budgetHelp')}
            </Typography>
        </>

    )
}

export default BudgetField;
